/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown>, total: NonNullable<unknown> }} Pagination_RangeInputs */

const cs_pagination_range = /** @type {(inputs: Pagination_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from}–${i?.to} z ${i?.total}`)
};

const en_pagination_range = /** @type {(inputs: Pagination_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from}–${i?.to} of ${i?.total}`)
};

/**
* | output |
* | --- |
* | "{from}–{to} of {total}" |
*
* @param {Pagination_RangeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pagination_range = /** @type {((inputs: Pagination_RangeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pagination_RangeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pagination_range(inputs)
	return cs_pagination_range(inputs)
});